import Component from "components/Component";
import TowerTable from "components/pricing/towerPricing/TowerTable";

/**
 * The Coverages tab's tower, built on the shared tower component rather than a
 * bespoke table — so it carries carrier, the expandable share table and the
 * share policy numbers, all of which the bespoke table lacked.
 *
 * Layers are added by typing into the trailing row, which the reducer turns
 * into a new tower layer, so no separate "Add Layer" button is needed here.
 */
const PrimaryTower = ({ onCopyLayer }) => (
  <Component title={"Tower"}>
    <TowerTable isNet={false} onCopyLayer={onCopyLayer} />
  </Component>
);

export default PrimaryTower;
